export const roleModeList = ['admin', 'viewer','editor'] as const;

export type RoleMode = typeof roleModeList[number];
